import React, {
  useEffect,
  useMemo,
  useState
} from "react";

import "./ImportFoodItemsPage.css";

export default function ImportFoodItemsPage() {

  // ==========================
  // CHANGE THIS
  // ==========================

  const restaurantId = localStorage.getItem( "restaurantId" );

  const API =
    "https://scanmymenu-nm38.onrender.com/api/restaurants/items";

  const ADD_ITEM_API =
    `https://scanmymenu-nm38.onrender.com/api/restaurants/${restaurantId}/items`;

  // ==========================
  // STATES
  // ==========================

  const [foodItems,
    setFoodItems] =
    useState([]);

  const [loading,
    setLoading] =
    useState(true);

  const [search,
    setSearch] =
    useState("");

  const [selectedCategory,
    setSelectedCategory] =
    useState("All");

  const [selectedItems,
    setSelectedItems] =
    useState([]);

  const [importing,
    setImporting] =
    useState(false);

    const [previewItem,
  setPreviewItem] =
  useState(null);

  // ==========================
  // FETCH ITEMS
  // ==========================

  useEffect(() => {

    fetchItems();

  }, []);

  const fetchItems =
    async () => {

      try {

        setLoading(true);

        const res =
          await fetch(API);

        const data =
          await res.json();

        // REMOVE DUPLICATES

        const uniqueMap =
          new Map();

        data.forEach((item) => {

          const key =
            item.name
              .trim()
              .toLowerCase();

          if (
            !uniqueMap.has(key)
          ) {

            uniqueMap.set(
              key,
              item
            );

          }

        });

        const uniqueItems =
          Array.from(
            uniqueMap.values()
          );

        setFoodItems(
          uniqueItems
        );

      }

      catch (error) {

        console.error(error);

      }

      finally {

        setLoading(false);

      }

    };

  // ==========================
  // CATEGORIES
  // ==========================

  const categories =
    useMemo(() => {

      const cats =
        foodItems.map(
          item => item.category
        );

      return [
        "All",
        ...new Set(cats)
      ];

    }, [foodItems]);

  // ==========================
  // FILTER
  // ==========================

  const filteredItems =
    useMemo(() => {

      return foodItems.filter(
        item => {

          const matchSearch =
            item.name
              .toLowerCase()
              .includes(
                search.toLowerCase()
              );

          const matchCategory =
            selectedCategory === "All"
              ? true
              : item.category === selectedCategory;

          return (
            matchSearch &&
            matchCategory
          );

        }
      );

    }, [
      foodItems,
      search,
      selectedCategory
    ]);

  // ==========================
  // SELECT ITEM
  // ==========================

  const toggleSelect =
    (item) => {

      const exists =
        selectedItems.find(
          selected =>
            selected.itemId === item.itemId
        );

      if (exists) {

        setSelectedItems(
          selectedItems.filter(
            selected =>
              selected.itemId !== item.itemId
          )
        );

      }

      else {

        setSelectedItems([
          ...selectedItems,
          item
        ]);

      }

    };

  // ==========================
  // IMPORT ITEMS
  // ==========================

  const importItems =
    async () => {

      if (
        selectedItems.length === 0
      ) {

        alert(
          "Select food items"
        );

        return;

      }

      try {

        setImporting(true);

        for (const item of selectedItems) {

          const formData =
            new FormData();

          formData.append(
            "name",
            item.name
          );

          formData.append(
            "description",
            item.description || ""
          );

          formData.append(
            "price",
            item.price || 0
          );

          formData.append(
            "category",
            item.category || ""
          );

          // IMAGE URL
          formData.append(
            "imageUrl",
            item.imageUrl || ""
          );

          // MODEL URL
          formData.append(
            "modelUrl",
            item.modelUrl || ""
          );

          await fetch(
            ADD_ITEM_API,
            {
              method: "POST",
              body: formData
            }
          );

        }

        alert(
          "Items imported successfully"
        );

        setSelectedItems([]);
        fetchItems();

      }

      catch (error) {

        console.error(error);

        alert(
          "Import failed"
        );

      }

      finally {

        setImporting(false);

      }

    };

  return (

    <div className="import-page">

      <div className="container">

        {/* HERO */}

        <div className="hero-section">

          <div>

            <h1>
              Import Food Items
            </h1>

            <p>
              Import food items into
              your restaurant menu.
            </p>

          </div>


        </div>

        {/* SEARCH */}

        <div className="filter-box">

          <input
            type="text"
            placeholder="Search food items..."
            className="search-input"
            value={search}
            onChange={(e) =>
              setSearch(
                e.target.value
              )
            }
          />

          <div className="category-list">

            {categories.map(
              (cat, index) => (

                <button
                  key={index}
                  className={
                    selectedCategory === cat
                      ? "category active"
                      : "category"
                  }
                  onClick={() =>
                    setSelectedCategory(cat)
                  }
                >

                  {cat}

                </button>

              )
            )}

          </div>

        </div>

        {/* ITEMS */}

        {loading ? (

          <div className="loading">

            Loading...

          </div>

        ) : (

          <div className="food-grid">

            {filteredItems.map(
              (item) => {

                const checked =
                  selectedItems.find(
                    selected =>
                      selected.itemId === item.itemId
                  );

                return (

                  <div
                    className="food-card"
                    key={item.itemId}
                  >

                    <div className="image-wrapper">

                      <img
                        src={item.imageUrl}
                        alt={item.name}
                      />

                      <span className="category-tag">

                        {item.category}

                      </span>

                      <input
                        type="checkbox"
                        className="check-box"
                        checked={checked}
                        onChange={() =>
                          toggleSelect(item)
                        }
                      />

                    </div>

                    <div className="food-content">

                      <div className="food-header">

                        <div>

                          <h2>
                            {item.name}
                          </h2>

                          <p>
                            {item.description}
                          </p>

                        </div>

                        <span className="price">

                          ₹{item.price}

                        </span>

                      </div>

                      <div className="card-buttons">

                       <button
                            className="preview-btn"
                            onClick={() =>
                                setPreviewItem(item)
                            }
                            >
                            Preview
                            </button>

                        <button
                          className="import-btn"
                          onClick={() =>
                            toggleSelect(item)
                          }
                        >

                          {
                            checked
                              ? "Selected"
                              : "Select"
                          }

                        </button>

                      </div>

                    </div>

                  </div>

                );

              }
            )}

          </div>

        )}

        {/* FLOAT BUTTON */}

        <button
          className="floating-btn"
          onClick={importItems}
        >

          {
              importing
                ? "Importing..."
                : "Import Selected"
            }
(
          {selectedItems.length}
          )

        </button>

        {
          previewItem && (

    <div
      className="preview-overlay"
      onClick={() =>
        setPreviewItem(null)
      }
    >

      <div
        className="preview-modal"
        onClick={(e) =>
          e.stopPropagation()
        }
      >

        {/* CLOSE BUTTON */}

        <button
          className="close-btn"
          onClick={() =>
            setPreviewItem(null)
          }
        >

          ✕

        </button>

        {/* FOOD IMAGE */}

        <img
          src={previewItem.imageUrl}
          alt={previewItem.name}
          className="preview-image"
        />

        {/* CONTENT */}

        <div className="preview-content">

          {/* CATEGORY */}

          <span className="preview-category">

            {previewItem.category}

          </span>

          {/* TITLE */}

          <h2>
            {previewItem.name}
          </h2>

          {/* DESCRIPTION */}

          <p className="preview-desc">

            {
              previewItem.description ||
              "No description available"
            }

          </p>

          {/* PRICE */}

          <div className="preview-price">

            ₹{previewItem.price}

          </div>

          {/* DETAILS */}

          <div className="preview-details">

           


            <div className="detail-card">

              <span className="detail-label">

                Available In AR

              </span>

              <span className="detail-value">

                {
                  previewItem.modelUrl
                    ? "Yes"
                    : "No"
                }

              </span>

            </div>


          </div>

          {/* BUTTONS */}

          <div className="preview-actions">

            {
              previewItem.modelUrl && (

                <a
                  href={previewItem.modelUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="model-btn"
                >

                  View 3D Model

                </a>

              )
            }

            <button
              className="import-preview-btn"
              onClick={() => {

                toggleSelect(
                  previewItem
                );

                setPreviewItem(null);

              }}
            >

              Import Food Item

            </button>

          </div>

        </div>

      </div>

    </div>

        )
        }


      </div>

    </div>

  );

}